import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from '../registration.service';
import { environment } from '@env/environment';
import { HttpService } from '@core/services/http.service';
import { forkJoin, Subject } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { take, takeUntil, finalize } from 'rxjs';
import { LocalService } from '@app/@core/services/local.service';
import { AppLoginService } from '@app/app-login/app-login.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading } from '@app/shared/constants/modal.model';
import { AlertService } from '@app/@core/services/alert.service';
 
@Component({
  standalone: false,
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit {
 
  passwordForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  allValidationsPass = false;
  showValidations = false;
  email: string;
  isLoading: boolean = false;
  isCapsLockOnNew: boolean = false;
  isCapsLockOnConfirm: boolean = false;
  genericMessages: any[] = [];
  genericMessage: any = {};
  errorMessages: any[] = [];
  errorMessage: any = {};
  toastMessages: any[] = [];
  toastDbMessage: any = {};
  personData: any;
  namesObj: any[]=[];
 formType: string;
  private backButtonAttempts = 0;
  userType: string = '';
  customModal: NgbModalRef;
  islea:boolean;
  isFp:boolean;
  isEpp:boolean;
 
  validations = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
    noPersonalInfo: true, // Assume true as we don't have personal info
    alphanumeric: false,
    noDictionaryWord: true // Assume true for simplicity
  };
private destroy$ = new Subject<void>();
 
  constructor(private readonly fb: FormBuilder, private readonly router: Router, private readonly registrationService: RegistrationService, private readonly route: ActivatedRoute, private readonly ngModal: NgbModal,
    private readonly httpService: HttpService,
    private location: LocationStrategy,
    private localstorage: LocalService,
    private appLoginService: AppLoginService,
    private alertService: AlertService 
  ) {
 this.preventBackButton();
  }
 
  shouldShowEmailField(): boolean {
    return (this.formType !== null && this.formType !== undefined && this.formType !== '');
  }
  getButtonText(): string {
    return this.shouldShowEmailField() ? 'Set Password' : 'Complete Registration';
  }
  
  checkCapsLock(event: KeyboardEvent, field: 'new' | 'confirm'): void {
    const isOn = event.getModifierState?.('CapsLock');
    if (field === 'new') {
      this.isCapsLockOnNew = isOn;
    } else if (field === 'confirm') {
      this.isCapsLockOnConfirm = isOn;
    }
  }
 
  hideCapsLockWarning(field: 'new' | 'confirm'): void {
    if (field === 'new') {
      this.isCapsLockOnNew = false;
    } else if (field === 'confirm') {
      this.isCapsLockOnConfirm = false;
    }
  }
 
  ngOnInit(): void {
    const errorMessagesData = localStorage.getItem('errorMessages');
    const genericMessagesData = localStorage.getItem('genericMessages');
    const toastMessagesData = localStorage.getItem('toastMessages');
      this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.email = params['email'];
        console.log('email:',this.email)
      }
      if (params['type']) {
        this.formType = params['type']
      }
      if (params['userType']) {
        this.userType = params['userType']
      }

      if(this.formType === 'lea'){
      this.islea = true;
    }else if(this.formType === 'fp'){
      this.isFp = true;
    }else if(this.formType === 'epp'){
      this.isEpp = true;
    }
    else{
      this.islea = false;
      this.isFp = false;
    }
    
    });
    if (!errorMessagesData || !genericMessagesData || !toastMessagesData || (this.namesObj.length === 0)) {
      this.loadDropdownData();
    } else {
      const storedErrorMessages = window.localStorage.getItem('errorMessages');
      this.errorMessages = JSON.parse(storedErrorMessages);
 
      this.errorMessage = {};
      this.errorMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.errorMessage[message.key] = message.value;
        }
      });
      const storedGenericMessages = window.localStorage.getItem('genericMessages');
      this.genericMessages = JSON.parse(storedGenericMessages);
 
      this.genericMessage = {};
      this.genericMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.genericMessage[message.key] = message.value;
        }
      });
      const storedToastMessages = window.localStorage.getItem('toastMessages');
      this.toastMessages = JSON.parse(storedToastMessages);
 
      this.toastDbMessage = {};
      this.toastMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.toastDbMessage[message.key] = message.value;
        }
      });
    }
 
 
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required]],
      confirmPassword: [{ value: '', disabled: true }, [Validators.required]]
    }, {
      validators: this.passwordMatchValidator
    });
    this.getRegistrationByEmail();
  }
  private async loadDropdownData() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get(`/registration/getNames?email=${this.email}`)
    ]).subscribe({
      next: (item: any) => {
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.genericMessages = item[2].data;
        this.namesObj=item[3].data.data;
        console.log('name:',this.namesObj);
        console.log('toastname:',this.toastMessages);
        // Process generic messages to make them easily accessible by key
        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('errorMessages', JSON.stringify(this.errorMessages));
        this.toastDbMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastDbMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('toastMessages', JSON.stringify(this.toastMessages));
        console.log(item);
        this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('genericMessages', JSON.stringify(this.genericMessages));
      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
 
  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
 
  checkPasswordValidation(): void {
    const password = this.passwordForm.get('password')?.value;
 
    if (!password) {
      this.resetValidations();
      this.passwordForm.get('confirmPassword')?.disable();
      return;
    }
 
    // Check minimum length (8 characters)
    this.validations.minLength = password.length >= 8 && password.length <17;
    
 
    // Check uppercase letter
    this.validations.uppercase = /[A-Z]/.test(password);
 
    // Check lowercase letter
    this.validations.lowercase = /[a-z]/.test(password);
 
    // Check for number
    this.validations.number = /\d/.test(password);
 
    //Personal Info
    this.validations.noPersonalInfo = this.checkNoPersonalInfo(password);
 
    // Check for special character
    this.validations.specialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
 
    // Check if alphanumeric plus special chars (all valid characters)
    this.validations.alphanumeric = /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/.test(password);
 
    // Check if all validations pass
    this.allValidationsPass = Object.values(this.validations).every(v => v === true);
 
    // Update form validity
    if (this.allValidationsPass) {
      this.passwordForm.get('password')?.setErrors(null);
      // CHANGED: Enable confirmPassword field when all validations pass
      this.passwordForm.get('confirmPassword')?.enable();  // CHANGED: Added this line
    } else {
      this.passwordForm.get('password')?.setErrors({ invalidPassword: true });
      // CHANGED: Disable confirmPassword field when validations fail
      this.passwordForm.get('confirmPassword')?.disable();  // CHANGED: Added this line
    }
  }
 
 
checkNoPersonalInfo(password: string): boolean {
  // Convert password to lowercase for case-insensitive comparison
  const passwordLower = password.toLowerCase();
 
  // Check if password contains any name from namesObj
  if (!this.namesObj || this.namesObj.length === 0) {
    // If no personal data is available, pass this validation
    return true;
  }
 
  for (const nameObj of this.namesObj) {
    // Check for first name
    if (nameObj.first_name && nameObj.first_name.trim() !== '' &&
        nameObj.first_name.length > 2 &&
        passwordLower.includes(nameObj.first_name.toLowerCase())) {
      return false;
    }
   
    // Check for middle name
    if (nameObj.middle_name && nameObj.middle_name.trim() !== '' &&
        nameObj.middle_name.length > 2 &&
        passwordLower.includes(nameObj.middle_name.toLowerCase())) {
      return false;
    }
   
    // Check for last name
    if (nameObj.last_name && nameObj.last_name.trim() !== '' &&
        nameObj.last_name.length > 2 &&
        passwordLower.includes(nameObj.last_name.toLowerCase())) {
      return false;
    }
  }
 
  // If no personal information found in password
  return true;
}
 
  resetValidations(): void {
    this.validations = {
      minLength: false,
      uppercase: false,
      lowercase: false,
      number: false,
      specialChar: false,
      noPersonalInfo: true,
      alphanumeric: false,
      noDictionaryWord: true
    };
    this.allValidationsPass = false;
 
    this.passwordForm.get('confirmPassword')?.disable();
  }
 
  passwordMatchValidator(form: FormGroup): { [key: string]: boolean } | null {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
 
    if (password && confirmPassword) {
      return password === confirmPassword ? null : { passwordMismatch: true };
    }
    return null;
  }
 
  
addExternalRegisteredPerson() {
  this.isLoading = true;
  this.personData = this.getRegistrationPayloadWithPassword();

  this.registrationService
    .addExternalRegisterDetails(this.personData, this.formType)
    .pipe(
      take(1),
      takeUntil(this.destroy$),
      finalize(() => {
        // Ensures we stop loading regardless of success/error/early returns
        // this.isLoading = false;
      })
    )
    .subscribe({
      next: (response: any) => {
        // Handle the "logical failure" response: data.success === false
        const data = response?.data;

        // Case 1: New contract - logical failure within 200
        if (data && typeof data === 'object' && data.success === false) {
          const msg =
            data.message ||
            'Failed to create user account. Please try again.';
          this.alertService.error(msg);
          console.error('Logical failure in registration:', data);
          return;
        }

        // Case 2: Old/alternate contract - array with p_user_id
        const userId =
          Array.isArray(data) && data[0]?.p_user_id
            ? data[0].p_user_id
            : // Some services may also return { p_user_id: '...' }
              data?.p_user_id;

        if (userId) {
          console.log('addRegisteredPerson Response:', userId);
          this.resetExternalPassword(userId);
          return;
        }

        // Fallback if no userId and not an explicit logical failure
        this.alertService.error(
          'Failed to create user account. Please try again.'
        );
        console.error('Error: Missing user ID in response', response);
      },
      error: (error) => {
        // Network/server errors or thrown errors
        const msg =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while creating your account.';
        this.alertService.error(msg);
        console.error('Registration API error:', error);
      }
    });
}

resetExternalPassword(userId: number){
  const resetPasswordData = {
    userId:  this.email,
    newPassword: this.passwordForm.get('password')?.value
  };
  this.appLoginService.resetPassword(resetPasswordData).pipe(take(1), takeUntil(this.destroy$)).subscribe({
    next: (response) => {
      console.log('Reset password API response:', response);
      this.setFirstTimeLoginForExternalUser(userId);
    },
    error: (error) => {
       this.isLoading = false;
        this.alertService.error(error?.error?.message || 'Failed to reset password. Please try again.');
      console.error('Reset password API error:', error);
    }
  });
}
 setFirstTimeLoginForExternalUser(userId: number) {
  this.httpService.post('/registration/set-first-time-login', { userId }).subscribe({
    next: (res) => {
      console.log('First time login flag set:', res);
      this.isLoading = false;
      this.openPasswordSuccessModal();
    },
    error: (err) => {
      this.isLoading = false;
      this.alertService.error(err?.error?.message || 'Failed to complete registration. Please try again.');
      console.error('Error setting first time login flag:', err);
    }
  });
}
 
  onSubmit(): void {
    if (this.isLoading) {
    return;
  }
    if (this.passwordForm.valid && this.allValidationsPass) {
      this.isLoading = true;
  if (this.userType === 'internal') {
      this.updateInternalUser();
    } else {
      if(!this.formType || this.formType === undefined) {
         this.addRegisteredPerson();
      }else{
        this.addExternalRegisteredPerson()
      }
    }
     
    }
  }
addUserToAzure(p_userId) {
  // Create the request body for Azure AD user creation
  const addUserRequest = {
    userId:p_userId,
    accountEnabled: true,
    displayName: `${this.personData.first_name} ${this.personData.last_name}`,
    mailNickname: this.personData.middle_name,
    userPrincipalName: this.email,
    passwordProfile: {
      forceChangePasswordNextSignIn: false,
      password: this.passwordForm.get('password')?.value
    }
  };
 
  this.registrationService.addUser(addUserRequest).subscribe({
    next: (response) => {
      console.log('Azure AD user created successfully:', response);
      if(response.status === 'success'){
      this.setFirstTimeLogin(p_userId);
      }else{
         this.isLoading = false;
      this.alertService.error( 'Failed to create Azure AD account. Please try again.');
      }
    },
    error: (error) => {
       this.isLoading = false;
      this.alertService.error(error?.error?.message || 'Failed to create Azure AD account. Please try again.');
      console.error('Error creating Azure AD user:', error);
    }
  });
}
 
 
  updateRegistrationStatus() {
    let input = {
      email: this.email,
      registrationStatus: 4
    }
    this.registrationService.updateRegistrationStatus(input).subscribe({
    next: (response) => {
      console.log('Registration status updated successfully:', response);
      this.sendRegistrationSuccessEmail();
    },
    error: (error) => {
      this.isLoading = false;
      this.alertService.error(error?.error?.message || 'Failed to update registration status.');
      console.error('Error updating registration status:', error);
    }
  });
}
sendRegistrationSuccessEmail() {
  let request = {
    email: this.email,
    front_end_domain: environment.frontEndDomain,
  };
  
  this.registrationService.registrationSuccessEmail(request)
    .pipe(take(1), takeUntil(this.destroy$))
    .subscribe({
      next: (response) => {
        console.log('Registration success email sent successfully:', response);
        this.isLoading = false;
        this.router.navigate(['/reg-form/verification-success']);
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.error(error?.error?.message || 'Registration completed but failed to send confirmation email.');
        console.error('Error sending registration success email:', error);
      }
    });
}
  getRegistrationByEmail() {
 
    this.httpService.get(`/registration/getRegistrationByEmail?email=${this.email}`).subscribe({
      next: (item: any) => {
        this.personData = item.data;
        console.log(item);
      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }
 
  // Static helper for password page: call this after password submit
  getRegistrationPayloadWithPassword() {
    const formDataStr = this.localstorage.getItem('externalRegistrationFormData');
    if (!formDataStr) return null;
    const formData = JSON.parse(formDataStr);
    return { ...formData,username: this.email,password:this.passwordForm.get('password')?.value };
  }
 
 
  addRegisteredPerson() {
    let input = {
      userName: this.email,
      Password: this.passwordForm.get('password')?.value,
      email: this.email,
      userRole: 405,
      firstName: this.personData.first_name,
      lastName: this.personData.last_name,
      middleName: this.personData.middle_name,
      birthDate: this.personData.birth_date,
      gender: this.personData.cd_gender,
      is_consent : this.personData.is_consent,
      is_channel : this.personData.is_channel,
      is_email_verified : this.personData.is_email_verified,
      is_phone_verified : this.personData.is_phone_verified,
      phoneNumber: this.personData.primary_phone,
      ssn : this.personData.ssn_number,
      suffix : this.personData.cd_suffix,
      itin : this.personData.itin_number,
      race : this.personData.cd_race,
      ethinicity : this.personData.cd_ethinicity,
      streetAddress: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      sessionId: "b4e09396-ae02-4d36-9d3e-cf6c1c74277b",
      performedBy: "1",
      performedRole: "1",
      ipAddress: "127.0.0.1",
      userAgent: 1,
      addressType: "1",
      registrationId:this.personData.registrationId,
      recovery_email: ""
    };
    if(this.personData.is_email_verified === true){
      input.recovery_email = this.personData.recovery_email;      
    }else{
      input.recovery_email = "";
    }
    this.registrationService.addRegisteredPerson(input).pipe(take(1), takeUntil(this.destroy$)).subscribe((response) => {
    if (response.status === 'success' && response.data[0].p_user_id) {
           console.log('addRegisteredPerson Response:', response.data[0].p_user_id);  
      const userId = response.data[0].p_user_id;    
     this.addUserToAzure(String(userId));
    }else{
       this.isLoading = false;
        this.alertService.error('Failed to register user. Please try again.');
      console.error('Error sending registration success email:')
    }
    }
      , (error) => {
        this.isLoading = false;
      this.alertService.error(error?.error?.message || 'Something went wrong during registration.');
        console.error('Error sending registration success email:', error);
      }
    );
  }
 @HostListener('window:popstate', ['$event'])
   onPopState(event: any): void {
     this.backButtonAttempts++;
     
     if (this.backButtonAttempts === 1) {
       alert('The browser Back button has been disabled. Please use our website\'s navigation menu options.');
       
       history.pushState(null, null, this.router.url);
     } else {
       alert('For security reasons, you will be redirected to the login page.');
       this.router.navigate(['/login']);
     }
   }
 
   private preventBackButton(): void {
     for (let i = 0; i < 3; i++) {
       history.pushState(null, null, window.location.href);
     }
     
     this.location.onPopState(() => {
       setTimeout(() => {
         if (this.backButtonAttempts >= 2) {
           this.router.navigate(['/login']);
         } else {
           history.pushState(null, null, window.location.href);
         }
       }, 50);
     });
   }
 
     setFirstTimeLogin(userId: number) {
  this.httpService.post('/registration/set-first-time-login', { userId, isFirstTime: true }).subscribe({
    next: (res) => {
      console.log('First time login flag set:', res);
      this.updateRegistrationStatus();
    },
    error: (err) => {
      this.isLoading = false;
      this.alertService.error(err?.error?.message || 'Failed to complete registration. Please try again.');
      console.error('Error setting first time login flag:', err);
    }
  });
}
updateInternalUser(): void {
  const payload = {
    email: this.email,
    username: this.email,
    password: this.passwordForm.get('password')?.value
  };
   this.appLoginService.updateInternalUser(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
    next: (response) => {
      if (response && response.status === 'success') {
        const userId = response.data?.data?.id;
         this.restPassword();
      } else {
          this.isLoading = false;
          this.alertService.error('Failed to update internal user. Please try again.');
          console.error('Error updating internal user: Invalid response');
        }
    },
    error: (error) => {
       this.isLoading = false;
        this.alertService.error(error?.error?.message || 'Something went wrong while updating user information.');
      console.error('Error updating internal user:', error);
    }
  });
}

restPassword() {
  const resetPasswordData = {
    userId: this.email,
    newPassword: this.passwordForm.get('password')?.value
  };
  
  this.appLoginService.resetPassword(resetPasswordData)
    .pipe(take(1), takeUntil(this.destroy$))
    .subscribe({
      next: (response) => {
        console.log('Reset password API response:', response);
        this.isLoading = false;
        this.openPasswordSuccessModal();
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.error(error?.error?.message || 'Failed to reset password. Please try again.');
        console.error('Reset password API error:', error);
      }
    });
}

openPasswordSuccessModal(): void {
  const options: NgbModalOptions = {
    backdrop: 'static',
    centered: true,
    size: 'md',
    keyboard: false
  };
 
  this.customModal = this.ngModal.open(ModalComponent, options);
 
  const modalConfig: ModalConfig = {
    buttons: [
      { text: 'Go to Login', code: 'LOGIN', btnOutline: false, navigate: '/login' }
    ],
    heading: 'Password Setup Complete',
    modalContent: 'Your password has been set successfully.<br> Please log in with your new credentials to continue.',
    hasTemplate: false,
    scrollable: false,
    hideCloseIcon: true,
    showLogo: true,
    logoSrc:'assets/images/checkmark.png'
  };
 
  this.customModal.componentInstance.modalConfig = modalConfig;
 
  this.customModal.componentInstance.emitData.subscribe((data: any) => {
       if (data.navigate) {
      this.router.navigate([data.navigate]);
    }
  });
}
   ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
 